<template>
  <div class="wellcomeScreen">
    <div class="wellcomeInfo">
      <!-- <h2 class="primaryHeader"> -->
      <h2 style="color:#666666">
        <vue-typer
          :text="`${greetings} ${userName}`"
          :type-delay="85"
          :repeat="0"
        ></vue-typer>
      </h2>
      <div class="video__bg">
        <video
          id="video"
          autoplay
          muted
          loop
          playsinline
          v-if="c_loader != ''"
          :key="c_loader"
        >
         <!--  <source
            src="@/assets/images/sp_plus.webm"
            type="video/webm; codecs=vp9,vorbis"
          /> -->
          <source :src="c_loader"  />
        </video>
        <!-- <video id="video" autoplay muted loop playsinline v-else>
          <source src="@/assets/images/sp_plus.webm" type="video/webm; codecs=vp9,vorbis" />
          <source src="@/assets/images/sp_plus.mp4" type="video/mp4" />
          <source src="@/assets/images/newLoader.mp4" type="video/mp4" />
        </video>-->
      </div>

      <!-- <div class="wellcome__loader">
        <img src="@/assets/images/fullres__sp__plus.gif" alt="Loader" />
      </div>-->
      <p class="txt--l my-4">
        You have
        <router-link to="/dashboard" class="txt--semi-bold txt--primary">
          <span v-if="unseen_activity == 0">no new activities</span>
          <span v-if="unseen_activity == 1"
            >{{ unseen_activity }} new activity</span
          >
          <span v-if="unseen_activity > 1"
            >{{ unseen_activity }} new activities</span
          >
        </router-link>
      </p>
      <router-link class="button button--primary button--md" to="/dashboard"
        >Continue</router-link
      >
    </div>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
export default {
  name: "Wellcome",
  components: { VueTyper },
  data() {
    return {
      user: {},
      userName: "",
      unseen_activity: 0,
      greetings: "",
      c_loader: "",
    };
  },
  created() {
    // this.getData();
    let loader = localStorage.getItem("loader");
    if(loader && loader!='' ) {
      this.c_loader = loader;
    }
    else {
      this.c_loader = require("@/assets/images/newLoader.mp4");
    }
    this.getActivity();
    this.getData();
    
  },
  mounted() {
    // window.onfocus = function () {
    //   document.getElementById("video").play();
    // };
    // window.onblur = function () {
    //   document.getElementById("video").pause();
    // };
  },
  methods: {
    getTiming() {
      const hour = new Date().getHours();
      this.greetings =
        "Good " +
        ((hour < 12 && "Morning") || (hour < 18 && "Afternoon") || "Evening") +
        ",";
    },
    getData() {
      this.axios
        .post(window.hostname + "api/auth/users", {
          mode: "details",
          device_type: "1",
          commercial: 1,
        })
        .then((res) => {
          console.log(res);
          this.getTiming();
          this.user = res.data.data;
          this.userName = this.user.first_name;
          if (this.user.loader !== "") {
            this.c_loader = this.user.loader;
          } else {
            // Adding default loader if property doesn't have any loader
            this.c_loader = require("@/assets/images/newLoader.mp4");
          }
        })
        .catch((error) => {
          // Adding default loader incase any error occur
          this.c_loader = require("@/assets/images/newLoader.mp4");
          console.log(error);
          // localStorage.removeItem("commercial_token_new");
          // this.$router.push({ name: "LandingPage" });
        });
    },
    getActivity() {
      this.axios
        .post(window.hostname + "api/auth/activity-count", {})
        .then((res) => {
          this.unseen_activity = res.data.data.count;
        })
        .catch((error) => {
          console.log(error);
          // localStorage.removeItem("commercial_token_new");
          // this.$router.push({ name: "LandingPage" });
        });
    },
  },
};
</script>

<style>
.custom.char.typed {
  color: inherit;
}
</style>
